"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubjectGroup = void 0;
//REMINDER: Changes to this type must also be made in graphql/typesDefs.ts
var SubjectGroup;
(function (SubjectGroup) {
    SubjectGroup["STEM"] = "STEM";
    SubjectGroup["HUMANITIES"] = "HUMANITIES";
    SubjectGroup["MFL"] = "MFL";
    SubjectGroup["OTHER"] = "OTHER";
})(SubjectGroup = exports.SubjectGroup || (exports.SubjectGroup = {}));
//# sourceMappingURL=SubjectGroup.js.map